
import { useState } from "react";
import JointForm from "components/addcustomer/joint/jointfrom";
import Nextkinfrom from "components/editcustomer/nextkin/nextkinfrom";
import AddCustomerLayout from "components/global/customereditlayout/AddCustomerLayout";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PulseLoader } from "react-spinners";


const NextOfKin = () => {
        const { id } = useParams();

        const [loading, setLoading] = useState(false);

      const formRef = useRef(); 
    
const navigate=useNavigate();


    const   dynamicName=(
        <div className="flex flex-col gap-1.5">
          <h2 className="page-heading">New Customer</h2>
        </div>
    );

      const submitButton = (
      <div className="flex items-center gap-2">
      <button 
       onClick={()=>
        navigate(`/app/Customer-detail/${id}/notifications`)}
      type="button" className="btn-secondary   w-fit">
        Skip
      </button>




        <button
        disabled={loading}
        type="button"
        className={`btn-primary py-2 px-6 w-fit ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
        onClick={() => !loading && formRef.current?.submitForm()}
      >
        {loading ? (
          <PulseLoader size={12} color="white" />
        ) : (
          "Next / Update"
        )}
      </button>
{/* 
      <button
        type="button"
        className="btn-primary py-2 px-6 w-fit"
        onClick={() => formRef.current?.submitForm()}
      >
        Next / Save
      </button> */}
    </div>
  );
  return (
    <AddCustomerLayout   dynamicName={dynamicName}  dynmicbutton={submitButton}>
    <Nextkinfrom ref={formRef} 

      loading={loading} 
      setLoading={setLoading}
    />
    </AddCustomerLayout>
  )
}

export default NextOfKin;